export default "__VITE_ASSET__CiF1EVur__"